module.exports = {
  "level1": {
    "name": "Nom réel",
    "address": "Adresse de la résidence actuelle",
    "bank_number": "Numéro de la carte bancaire",
    "wc": "Confimer",
    "name_nodata": "Le nom ne peut pas être vide",
    "id_card_nodata": "Le numéro d'identification ne peut pas être vide",
    "address_nodata": "L'adresse ne peut pas être vide",
    "bank_number_nodata": "Le numéro de la carte bancaire ne peut pas être vide",
    "input-username": "Veuillez entrer votre vrai nom",
    "zjhm": "Numéro d'identification",
    "input-idcard": "Veuillez entrer votre numéro d'identification",
    "input-address": "Veuillez entrer votre adresse",
    "zjlx": "Types de pièces d'identité",
    "qxzzjlx": "Veuillez sélectionner le type de pièce d'identité",
    "sfz": "Carte d'identité",
    "hz": "Passeport",
    "jsz": "Permis de conduire",
    "khh": "Banque d'ouverture de compte",
    "qsrkhh": "Veuillez saisir la banque",
    "yhkh": "Numéro de la carte bancaire",
    "qsryhkh": "Veuillez entrer votre numéro de carte bancaire",
    "gjlb": "Liste des pays",
    "qxzgjlb": "S'il vous plaît sélectionnez Pays / Région"
  },
  "my": {
    "mqrcode": "Mon code QR",
    "as": "Paramètres",
    "pc": "Certification junior",
    "ac": "Certification avancée",
    "ms": "Partager",
    "me": "Mes revenus",
    "zsr": "Revenus totaux",
    "mp": "Mes promotions",
    "yqhy": "Inviter des amis",
    "ar": "record",
    "hc": "Centre d'aide",
    "nodata": "Aucune donnée disponible",
    "med": "Répartition des revenus",
    "aes": "Revenu cumulé (USDT)",
    "one": "1ère génération     ",
    "two": "2ème génération",
    "three": "3ème génération",
    "four": "Quatrième génération",
    "ones": "Nombre de personnes 1ère génération",
    "twos": "Nombre de personnes 2ème génération",
    "threes": "Nombre de personnes 3ème génération",
    "fours": "Nombre de personnes 4ème génération",
    "promotion": "Nombre d'affiliés",
    "customers": "Mes revenus",
    "wdzc": "Mes Avoirs",
    "wdzc1": "Mes Avoirs",
    "wyfx": "Partager",
    "wdsy": "Mes revenus",
    "wdtg": "Mes promotions",
    "zhjl": "record",
    "zxkf": "Nous contacter",
    "wdxx": "Mes messages",
    "smrz":"Authentification KYC",
    "sfyz":"Authentification KYC"
  },
  "footer": {
    "home": "Accueil",
    "quotation": "Marchés",
    "currency": "Exchange",
    "lever": "Contrats",
    "my": "Compte",
    "lc": "Intérêts Compte courant"
  },
  "index": {
    "wdzc": "Mes Avoirs (USDT)",
    "dl": "connexion",
    "zxkf": "Nous contacter",
    "increase": "Gagnants",
    "usercenter": "Centre personnel",
    "security": "Centre de sécurité",
    "address": "Adresse de retrait",
    "aboutus": "A propos de nous",
    "vol": "Volume 24H",
    "kjcb": "Dépôt",
    "zcbz": "BTC, USDT...",
    "logout":"Se déconnecter",
    "language":"Langue"
  },
  "transaction": {
    "buy": "Acheter",
    "sell": "Vendre",
    "pwd": "Mot de passe de paiement",
    "inputnum": "Entrez la quantité",
    "limit": "Limite",
    "avaiable": "Disponible",
    "turnover": "Montant de la transaction",
    "handicap": "Handicap",
    "number": "Quantité",
    "nonumber": "Quantité restante",
    "numbered": "Quantité achevée",
    "price": "Prix",
    "marketprice": "Prix du Marché",
    "cancel": "Annuler",
    "time": "Temps",
    "nomore": "Plus rien",
    "nodata": "Pas d'historique",
    "getmore": "Charger plus",
    "mycommission": "Tous les Ordres-stops",
    "currentbuy": "Ordre actuel (Achat)",
    "currentsell": "Ordre actuel (Vente)    ",
    "his": "Historique(Achevé)",
    "currency": "Devise",
    "option": "Opération",
    "wtime": "Temps d'achèvement",
    "wnumber": "Quantité achevée",
    "wprice": "Prix d'achèvement"
  },
  "mk": {
    "high": "Haut",
    "low": "Bas",
    "vol": "Volume 24H",
    "newPrice": "Dernier prix",
    "product": "Produit",
    "name":"Nom",
    "rank": "Gagnants"
  },
  "deals": {
    "issue_time": "Heure d'émission",
    "issue_number": "Numéro d'émission",
    "white_book": "Livre blanc",
    "weburl": "Site web officiel",
    "video_url": "Vidéo",
    "introduction": "Introduction",
    "onhand": "1lot =",
    "position": "Position",
    "leverorder": "Ordres à effet de levier",
    "leverposition": "Position à effet de levier",
    "inputprice": "Prix d'entrée",
    "inputmul": "Entrez un levier",
    "selectmul": "Choisir un levier",
    "onehand": "1lot =",
    "hand": "Nombre de lots",
    "marketval": "Valeur Marchande",
    "bond": "Marge",
    "balance": "Balance",
    "type": "Type",
    "risk": "Ratio de risque",
    "total": "Bénéfice Total",
    "onekey": "Liquidation en un clic",
    "makemore": "(Achat)",
    "makeless": "(Vente)",
    "current": "Ordres ouverts",
    "all": "Tout",
    "weing": "Ordre en cours",
    "tding": "Trading",
    "ping": "Clôture",
    "pied": "Fermé",
    "ceiled": "Retiré",
    "weprice": "Prix de la commande",
    "oprice": "Ouvrir",
    "nowprice": "Prix actuel",
    "zyprice": "Prendre des bénéfices",
    "zsprice": "Prix du Stop Loss",
    "canbond": "Marge disponible",
    "optime": "Temps ouvert",
    "pgtime": "Heure de fermeture",
    "znum": "Quantité convertie",
    "gprice": "Frais de Session Nocturne",
    "pcang": "Position fermée",
    "revoke": "Annuler l'ordre",
    "fee": "Frais",
    "you": "Négocier au meilleur prix actuel"
  },
  "assets": {
    "copy": "Copier",
    "avaiable": "Disponible",
    "lock": "Geler",
    "conversion": "Convertir",
    "exact": "Compte de trading",
    "num": "Quantité",
    "time": "Temps",
    "all": "Tous",
    "canuse": "Disponible",
    "cmoney": "Dépôt",
    "tmoney": "Retrait",
    "caddress": "Adresse de dépôt",
    "copyaddress": "Copier l'adresse",
    "taddress": "Adresse de retrait",
    "taddressm": "Veuillez entrer l'adresse de retrait",
    "rate": "Frais",
    "dnum": "Montants crédités",
    "more": "Charger plus",
    "nodata": "Pas d'historique",
    "yczc": "Masquer les soldes nuls",
    "total":"Conversion d'actifs (USDT)"
  },
  "td": {
    "drecord": "Historique des ordres",
    "orecord": "Ordres terminés",
    "filter": "Filtrer",
    "dstatus": "Statut de l'ordre",
    "nofinish": "Annulé",
    "finished": "Exécuté",
    "ceiled": "Annulé",
    "reset": "Réinitialiser",
    "confirm": "Confimer",
    "time": "Temps",
    "num": "Quantité",
    "price": "Prix",
    "ptime": "Heure de la commande",
    "receiver": "Bénéficiaire",
    "open": "Banque d'ouverture de compte",
    "pwd": "Mot de passe de paiement",
    "ppwd": "Veuillez saisir le mot de passe de paiement",
    "sure": "Confimer",
    "realName": "Nom réel",
    "pnum": "Veuillez saisir le montant",
    "buyNum": "Montant de l'achat",
    "currency": "Devise"
  },
  "fat": {
    "ceil": "Annuler",
    "num": "Quantité",
    "submit": "Passer un ordre",
    "pwd": "Mot de passe de paiement",
    "ppwd": "Veuillez saisir le mot de passe de paiement",
    "sure": "Confirmer",
    "auHigh": "Certification avancée"
  },
  "auth": {
    "bh": "Rejeté",
    "mycenter": "Centre personnel",
    "test": "Authentification",
    "testing": "En cours de vérification",
    "name": "Nom",
    "account": "Compte",
    "id_card_face": "Veuillez téléverser le recto de votre carte d'identité",
    "id_card_back": "Veuillez téléverser le verso de votre carte d'identité",
    "updata": "Soumettre",
    "updata_again": "Soumettre à nouveau"
  },
  "code": {
    "notice": "Avis     "
  },
  "safe": {
    "title": "Sécurité du compte",
    "center": "Centre de sécurité",
    "yysz": "Langue",
    "ssms": "Mode sombre   ",
    "gywm": "A propos de nous",
    "lgpwd": "Mot de passe de connexion",
    "resetpwd": "Modifier le mot de passe",
    "paccount": "Veuillez saisir votre numéro de téléphone portable ou votre adresse électronique",
    "reset": "Modifier",
    "ceil": "Annuler",
    "pcode": "le code de vérification",
    "sure": "Confirmer",
    "newPwd": "Réinitialiser le mot de passe",
    "ppwd": "Veuillez entrer votre mot de passe",
    "reppwd": "Veuillez entrer à nouveau votre mot de passe",
    "repwd": "Réinitialiser le mot de passe",
    "zpwd": "Mot de passe de paiement"
  },
  "met": {
    "open": "Nom de la banque",
    "bank": "Numéro de compte bancaire",
    "realname": "Nom réel",
    "save": "Enregistrer",
    "popen": "Veuillez entrer le nom de votre banque",
    "pbank": "Veuillez saisir le numéro de compte de la banque",
    "pname": "Veuillez entrer votre vrai nom"
  },
  "ads": {
    "tas": "Adresse de retrait",
    "address": "Adresse",
    "noads": "Vous n'avez pas encore d'adresse",
    "adds": "Adresse",
    "remark": "Remarque",
    "cel": "Supprimer"
  },
  "jc": {
    "ppwd": "Veuillez entrer votre mot de passe"
  },
  "lg": {
    "welcome": "Bienvenue ! Veuillez vous connecter",
    "lgtel": "Connexion avec le Numero de téléphone",
    "lgeml": "Connexion avec l'E-mail",
    "paccount": "Numéro de téléphone ou e-mail",
    "ppwd": "Veuillez entrer votre mot de passe",
    "ppwd2": "Veuillez confirmer votre mot de passe",
    "pcode": "le code de vérification",
    "qsryqm": "le code de vérification",
    "noaccount": "Vous n'avez pas encore de compte ?",
    "register": "S'inscrire",
    "phregister": "Inscription avec le Numero de téléphone",
    "emregister": "Inscription avec l'E-mail",
    "pphone": "numéro de téléphone portable",
    "ceil": "Annuler",
    "send": "Obtenir CAPTCHA",
    "sure": "Confimer",
    "email": "adresse e-mail",
    "emtest": "Vérification de l'e-mail",
    "pemcode": "le code de vérification",
    "ppcode": "le code de vérification",
    "ftpwd": "Vous avez oublié votre mot de passe ?",
    "ptext": "Veuillez saisir votre numéro de téléphone portable ou votre adresse électronique",
    "yzm": "Code de vérification",
    "mm": "Mot de passe",
    "qrmm": "Confirmer le mot de passe",
    "language":"Langue",
    "qregister":"S'inscrire",
    "lgs":"connexion",
    "kjzc": "Contactez-nous pour une inscription rapide",
    "kjzc1": "Vous ne pouvez pas recevoir de Captcha ?",
    "kjzc2": "Inscription rapide",
    "wyzx": "je sais déjà",
    "qtxyxzh": "Important: Veuillez renseigner une adresse e-mail ou un numéro de téléphone portable valide, qui peut être utilisé pour récupérer votre mot de passe",
    "next": "L'étape suivante"
  },
  "gjrz": {
    "title": "Certification avancée",
    "t1": "1. Les images inférieures à 8MB et aux formats JPG JPEG ou PNG sont supportées.",
    "t2": "2. Les photos des documents d'identité doivent être claires et ne doivent pas être modifiées ou obstruées. Le numéro du document d'identité avec photo et le nom du titulaire du document doivent être clairement visibles.",
    "t3": "3. Les photos doivent être prises la tête nue, sans couvre-chef et il est recommandé de ne pas se maquiller. Les traits du visage sur la photo doivent être clairs et reconnaissables et les bras doivent être entièrement exposés.",
    "t4": "Confimer",
    "bh": "Rejeté",
    "shz": "En cours de vérification",
    "shtg": "Vérifié",
    "sczjz": "Téléverser une photo d'identité",
    "sczjzmz": "Téléverser la photo du recto de la pièce d'identité",
    "sczjbmz": "Téléchargez la photo du verso de la pièce d'identité",
    "scgrqmz": "Télécharger les documents d'identité et votre signature personnelle"
  },
  "chongzhi": {
    "title": "Dépôt",
    "cbjl": "Historique des dépôts",
    "t1": "Quantité",
    "t2": "Veuillez saisir le montant",
    "t3": "Description du bon(Optionnel)",
    "t4": "Veuillez saisir la description",
    "t5": "Image du bon d'achat",
    "t6": "Confimer",
    "t7": "Nom de la chaîne",
    "t8": "Code QR",
    "t9": "Enregistrer le code QR",
    "t10": "Adresse de dépôt",
    "t11": "Copier",
    "zy": "Important",
    "tips1": "Veuillez ne pas recharger des actifs qui ne sont pas dans cette devise à l'adresse ci-dessus, sinon les actifs ne pourront pas être récupérés",
    "tips2": "1. Compatibilité portefeuille/plateforme : c'est-à-dire que le réseau est pris en charge ; si la plate-forme cible ne prend pas en charge votre réseau de retrait, les actifs ne peuvent pas être récupérés.",
    "tips3": "2. Votre réseau de recharge et la plate-forme cible sont les mêmes ; si vous choisissez l'adresse cible est le réseau Ethereum, mais que la recharge choisit la chaîne intelligente TRC20, vous ne pourrez peut-être pas récupérer vos actifs numériques.",
    "tips4": "3. Assurez-vous que votre adresse et votre montant sont corrects avant de recharger.",
    "tips5": "Rappel : En raison de l'anonymat et de la confidentialité du réseau de blocage, une fois que vous avez entré des informations erronées, vous perdrez les actifs correspondants. S'il vous plaît vérifier votre adresse de recharge et la quantité soigneusement"
  },
  "tibi": {
    "title": "Se désister",
    "tbjl": "Historique des retraits",
    "t1": "Adresse de retrait",
    "t2": "Veuillez entrer l'adresse de retrait",
    "t3": "Montant du retrait",
    "qsrtbsl": "Veuillez saisir le montant de la devise de retrait",
    "t4": "Retrait minimum",
    "t5": "Mot de passe de paiement",
    "t6": "Veuillez saisir le mot de passe de paiement",
    "t7": "Frais",
    "t8": "Montants crédités",
    "t9": "Confimer",
    "sc": "Supprimer",
    "bj": "Modifier",
    "bq": "Tags(Memo)",
    "qsrbq": "Veuillez entrer le tag",
    "yhktx": "Retrait par carte bancaire",
    "yhmc": "Nom de la banque",
    "qsryhmc": "Veuillez entrer le nom de votre banque",
    "yhzh": "Numéro de compte bancaire",
    "qsryhzh": "Veuillez saisir le numéro de compte bancaire",
    "gjhkdm": "Code SWIFT",
    "qsrgjhkdm": "Veuillez saisir le code SWIFT",
    "yhdz": "Adresse de la banque",
    "qsryhdz": "Veuillez saisir l'adresse de la banque",
    "skrxm": "Nom du bénéficiaire",
    "qsrskrxm": "Veuillez saisir le nom du bénéficiaire",
    "skrdh": "Téléphone du bénéficiaire",
    "qsrskrdh": "Veuillez saisir le numéro de téléphone du bénéficiaire",
    "skrdz": "Adresse du bénéficiaire",
    "qsrskrdz": "Veuillez saisir l'adresse du bénéficiaire"
  },
  "huazhuan": {
    "t4": "Veuillez saisir le montant",
    "ky": "Disponible",
    "t10": "Confimer"
  },
  "banner": {
    "title": "Détails"
  },
  "download": {
    "t1": "transactions, partout",
    "xz": "Télécharger"
  },
  "xgdlmm": {
    "title": "Modifier le mot de passe de connexion",
    "zh": "Compte",
    "yzm": "Code de vérification",
    "yzmts": "le code de vérification",
    "hqyzm": "Obtenir CAPTCHA",
    "mm": "Mot de passe",
    "qrmm": "Confirmer le mot de passe",
    "qr": "Confirmer",
    "zhts":"Téléphone portable ou e-mail",
    "mmts":"Longueur du mot de passe 6-12 combinaisons alphanumériques"
  },
  "sztkmm": {
    "title": "Définir le mot de passe de retrait",
    "dlmm": "Mot de passe de connexion",
    "dlmmts": "Veuillez entrer votre mot de passe de connexion",
    "xmm": "Nouveau mot de passe",
    "mmts": "Longueur du mot de passe : 6 chiffres",
    "qrmm": "Confirmer le mot de passe",
    "qr": "Confirmer",
    "qd": "Confimer",
    "sztkts": "Conseil : Veuillez vous rendre dans le Centre de sécurité pour définir le mot de passe de paiement."
  },
  "rule": {
    "title": "Règles d'activité",
    "title2": "Règles",
    "title3": "Activité"
  },
  "news": {
    "title": "Mes messages",
    "ckxq": "Afficher les détails",
    "gg": "Avis"
  },
  "search": {
    "qx": "Annuler"
  },
  "wdtg": {
    "wdyqlj": "Mon lien d'invitation",
    "wdyqm": "Mon code d'invitation",
    "schbyq": "Générer des invitations à poster",
    "ljtgsy": "Gains cumulés d'affiliation",
    "tkrs": "Nombre d'invitations",
    "ljyj": "Commission cumulée",
    "yjmx": "Détails de la Commission",
    "ljyjjl": "Bonus de commission cumulatif (usdt)",
    "ljsy": "Bénéfices cumulés",
    "ljyqjl": "Bonus d'invitation cumulatif (usdt)",
    "fxd": "Partager",
    "bctp": "Sauvegarder l'image",
    "qx": "Annuler",
    "t3": "Identifiez l'image ou scannez-la"
  },
  "bzhl": {
    "title": "Remises de détention",
    "gz": "Règles",
    "tgdd": "Ordre de dépôt fiduciaire",
    "zztgdzj": "Fonds en dépôt",
    "yjjrsy": "Revenus du jour",
    "ljsy": "Bénéfices cumulés",
    "tgzdd": "Ordres en dépôt fiduciaire",
    "cljxcp": "Produits de campagne stratégique",
    "dbxe": "Limite unique",
    "rsyl": "Taux de rendement quotidien",
    "zq": "Cycle",
    "qmr": "Achat immédiat",
    "bbzhzc": "Actifs du compte",
    "dd": "Ordres",
    "buy": "Acheter",
    "jxcp": "Produits vedettes",
    "ckdd": "Vérifier la commande",
    "gd": "Plus",
    "xzbzts": "Simple et sûr. Les dividendes peuvent être sélectionnés dans plusieurs devises",
    "qtbz": "Autres pièces"
  },
  "bzhlgm": {
    "qtzq": "Cycle de 7 jours USDT",
    "rsyl": "Rendement(%)",
    "lczq": "Cycle financier",
    "dbxe": "Limite unique",
    "pxsj": "Date de versement des dividendes",
    "mr": "Journalier",
    "dqfh": "Rendement à l'échéance",
    "tgzj": "Capital en dépôt",
    "tqsh": "Remboursement anticipé",
    "yjsy": "Revenu anticipé (USDT)",
    "kyzc": "Actifs disponibles (USDT)",
    "cpjs": "Description du produit",
    "tgje": "Montant détenu en fiducie",
    "qsrtgje": "Veuillez entrer le montant du dépôt fiduciaire",
    "qb": "Tout",
    "rm": "Achat immédiat",
    "cpzq": "Cycle du produit",
    "gz": "Découvrez les règles et les avantages"
  },
  "bzhlwdtg": {
    "title": "Statut de l'ordre",
    "tgz": "En dépôt fiduciaire",
    "ywc": "Exécuté",
    "ysh": "Remboursé",
    "tgje": "Montant détenu en fiducie \/ Jours par cycle",
    "rsyl": "Taux de rendement quotidien",
    "yhl": "Bénéfice gagné \/ Jours restants",
    "xdsj": "Heure de la commande",
    "sh": "Rachat",
    "ddxq": "Détails de la commande",
    "ddh": "Numéro de commande"
  },
  "bzjj": {
    "t1": "Gains quotidiens",
    "cpld": "Points forts du produit",
    "scsq": "Dépôt et retrait à tout moment",
    "pxzq": "Cycle des dividendes",
    "mtxf": "Distribuer quotidiennement",
    "hqlx": "Intérêt courant",
    "zj": "Fonds à 100%.",
    "aqbz": "Sécurité",
    "jjrsy": "Revenus de vacances",
    "sybjd": "Bénéfice continu",
    "bjd": "Ininterrompu",
    "cgcrh": "Après un dépôt réussi",
    "dtqx": "Valeur des intérêts le jour même",
    "jglz": "Par exemple",
    "syjs": "Calcul des gains",
    "cont2": "Minimum : 10 000U x 0,3% - 30U",
    "cont3": "Maximum : 10 000U x 0,5% - 50U",
    "gywyj": "À propos des dommages-intérêts liquidés",
    "wycy": "Je veux participer"
  },
  "zyzs": {
    "title": "Take Profit et Stop Loss",
    "zy": "Stop Profit",
    "zs": "Stop Loss",
    "qsrzyjg": "Veuillez entrer un prix take profit",
    "qsrzsjg": "Veuillez entrer un prix stop loss",
    "scjg": "Prix du marché",
    "wxts": "Rappel :",
    "qr": "Confirmer"
  },
  "bbjy": {
    "mr": "Acheter",
    "mc": "Vendre",
    "mai": "Acheter",
    "sell": "Vendre",
    "xj": "Limite",
    "sj": "Marché",
    "pk": "Handicap",
    "jg": "Prix",
    "sl": "Quantité",
    "mrl": "Volume d'achat",
    "ss": "Quantité",
    "mcl": "Volume de vente",
    "ky": "Disponible",
    "km": "Disponible à l'achat",
    "ksell": "Disponible à la vente",
    "jye": "Montant de la transaction",
    "dqwt": "Ordres ouverts",
    "lswt": "Historique des commissions",
    "jj": "Introduction",
    "wtzl": "Total",
    "wtjg": "Prix de la commission",
    "ycjl": "Volume de transactions achevées",
    "cjjj": "Prix moyen de la transaction",
    "cd": "Annuler l'ordre",
    "xd": "Passer un ordre",
    "ywc": "Exécuté",
    "ycd": "Retiré",
    "wqcj": "Transaction complète",
    "zx": "En option",
    "scjg": "Prix du marché",
    "fhsj": "Heure d'émission",
    "fhsl": "Numéro d'émission",
    "bps": "Livre blanc",
    "gw": "Site web officiel",
    "qx": "Annuler"
  },
  "hyjy": {
    "mai": "Acheter",
    "sell": "Vendre",
    "kc": "Positions ouvertes",
    "pc": "Position fermée",
    "cc": "Positions",
    "kp": "Fermer",
    "kpc": "Fermer les positions courtes",
    "kcc": "Positions",
    "kkd": "Long ouvert",
    "kpd": "Fermeture longue",
    "kkk": "Ouvert Court",
    "xj": "Limite",
    "sj": "Prix du Marché",
    "xjwt": "Ordres à cours limité",
    "sjwt": "Ordre du marché",
    "pk": "Handicap",
    "jg": "Prix",
    "sl": "Quantité",
    "gg": "Effet de levier",
    "tzgg": "Ajuster l'effet de levier",
    "ggbs": "Effet de levier",
    "mrl": "Volume d'achat",
    "ky": "Disponible",
    "jye": "Montant de la transaction",
    "dqwt": "Ordres ouverts",
    "lswt": "Historique des commissions",
    "ptwt": "Ordre ordinaire",
    "dqwtmr": "Ordre actuel (Achat)",
    "dqwtmc": "Ordre actuel (Vente)    ",
    "hywt": "Contrats",
    "jj": "Introduction",
    "wtzl": "Total",
    "wtjg": "Prix de la commission",
    "ycjl": "Volume de transactions achevées",
    "cjjj": "Prix moyen de la transaction",
    "cd": "Annuler l'ordre",
    "xd": "Passer un ordre",
    "wqcj": "Transaction complète",
    "ywc": "Exécuté",
    "ycd": "Retiré",
    "zx": "En option",
    "scjg": "Prix du marché",
    "fhsj": "Heure d'émission",
    "fhsl": "Numéro d'émission",
    "bps": "Livre blanc",
    "gw": "Site web officiel",
    "mrzd": "Achater long",
    "mrpk": "Acheter court ",
    "mczk": "Vendre à découvert ",
    "mcpd": "Vendre long",
    "mrkdkz": "Achater ouvert (haussier)",
    "mrpkkz": "Achater à la clôture (haussier)",
    "mckkkd": "Vendre ouvert (baissier)",
    "mcpdkd": "Vente à la clôture (baissière)",
    "yxhy": "Contrat perpétuel",
    "dc": "Positions longues",
    "syl": "Taux de rendement",
    "bzjl": "Taux de marge",
    "tzbzj": "Ajustement des marges",
    "zyzs": "Take Profit et Stop Loss",
    "zhang": "Quantité",
    "qblx": "Tous les types",
    "qb": "Tout",
    "ccjg": "Position Prix",
    "ccsl": "Quantité de la position",
    "yk": "Profits et pertes",
    "ccsj": "Position Durée",
    "zy": "Stop Profit",
    "zs": "Stop Loss",
    "zje": "Montant total",
    "kcs": "Quantité de la position ouverte",
    "kcjg": "Prix de la position ouverte",
    "ss": "Nombre de lots",
    "hand": "1 lot =",
    "qx": "Annuler",
    "qr": "Confirmer",
    "qbcd":"Annuler toutes les commandes"
  },
  "kxt": {
    "gao":"H",
    "di":"L",
    "wtgd": "Ordre en attente",
    "cj": "Transaction",
    "jj": "Introduction",
    "sj": "Temps",
    "fx": "Direction",
    "jg": "Prix",
    "sl": "Quantité",
    "mr": "Acheter",
    "mc": "Vendre",
    "mp": "Enchère",
    "sp": "Vente",
    "slb": "Quantité",
    "fhsj": "Heure d'émission",
    "fhsl": "Numéro d'émission",
    "bps": "Livre blanc",
    "gw": "Site web officiel",
    "fz":"min",
    "xs":"hour",
    "tian":"day",
    "zhou":"week",
    "yue":"month",
    "gd":"More",
    "ft": "Image latérale",
    "zt": "Image principale",
    "sdt": "Profondeur",
    "zx": "En option",
    "djck": "Clique pour voir"
  },
  "zhjl": {
    "cbtb": "Dépôt et retrait",
    "jymx": "Détails de la transaction",
    "tgyj": "Commission de promotion",
    "wwc": "Annulé",
    "ywc": "Exécuté"
  },
  "zwsj": {
    "title": "Aucune donnée disponible"
  },
  "bzxz": {
    "title": "Sélectionnez la devise"
  },
  "jghy": {
    "jghy": "Swap",
    "yxhy": "Perpétuel",
    "mz": "Haussier",
    "md": "Baissier",
    "gmj": "Prix d'achat",
    "jsj": "Prix de règlement",
    "xj": "Prix au comptant",
    "fx": "Direction",
    "sl": "Quantité",
    "jgsj": "Temps de règlement",
    "gb": "Fermer",
    "jxxd": "Continuer à passer les ordres",
    "cclb": "Liste des ordres",
    "zc": "Actif",
    "lscc": "Historique",
    "qblx": "Tous les types",
    "yk": "Profits et pertes",
    "ddqr": "Confirmation de l'ordre",
    "dqsj": "Délai d'expiration",
    "jssj": "Temps de règlement",
    "sy": "Gain",
    "tzje": "Montant de l'investissement",
    "zdje": "Montant de l'investissement supérieur à 0",
    "kyye": "Équilibre: ",
    "kyye2": "Équilibre",
    "sxf": "Frais: ",
    "sxfl": "Frais",
    "jypz": "Nom",
    "jyfx": "Direction",
    "qrxd": "Confirmer",
    "dqye": "Solde actuel"
  },
  "kjmb": {
    "title": "Crypto-monnaie",
    "gm": "Acheter USDT",
    "wxts": "Rappel :",
    "copy": "Copier",
    "ljmb": "Acheter de la crypto-monnaie",
    "qx": "Annuler",
    "gmsl": "Montant de l'achat",
    "cssl": "Montant vendu",
    "qsrgmsl": "Veuillez indiquer le nombre d'achats",
    "qsrcssl": "Veuillez entrer la quantité à vendre",
    "jg": "Prix",
    "fzcg": "Copy successfully"
  },
  "tips": {
    "jymm": "Mot de passe de paiement",
    "szjymm": "Définir le mot de passe de retrait",
    "qsrjymm": "Veuillez saisir le mot de passe de paiement",
    "jymmts": "Veuillez vous rendre dans le Centre de sécurité pour définir le mot de passe de la transaction."
  },
  "xyf":{
    "title": "Pointage de crédit",
    "pgsj": "Temps d'évaluation"
  },
  "dzrz":{
    "title": "Authentification d'adresse",
    "sdddz":"Adresse de facturation des services publics",
    "tpsc": "Téléchargement d'image de facture",
    "ts": "Rappel : Vous devez remplir les informations d'adresse et soumettre la facture de services publics ou la facture d'adresse à large bande",
    "tips":"Vous devez remplir les informations d'adresse et soumettre la facture de services publics ou la facture d'adresse à large bande",
    "qsczdtp":"Téléchargement d'image de facture"
  },
  "newReg":{
    "sjh": "téléphone portable",
    "yx": "e-mail",
    "yqm": "Code d'invitation",
    "yqm2": "Code d'invitation (facultatif)",
    "cjzh": "Créer un compte",
    "sysjhzyx": "S'inscrire avec un numéro de portable/e-mail",
    "sj": "Mobile",
    "yhxy": "&lt;Contrat d'utilisation&gt;",
    "yhxy2": "J'ai lu et j'accepte les et &lt;Contrat d'utilisation&gt;"
  },
  "mbwt":{
    "title": "Paramètres des problèmes de sécurité",
    "mbwt": "Les problèmes de sécurité",
    "qtxda": "Veuillez remplir la réponse",
    "qsrxmm": "Veuillez saisir un nouveau mot de passe",
    "sydqmmcz": "Utiliser la réinitialisation du mot de passe actuel",
    "zhmm": "Problèmes de sécurité Récupérer le mot de passe",
    "ysz": "A été mis en",
    "tg": "franchir",
    "tj": "nous faire parvenir",
    "zyts": "Important:",
    "zytsCont": "Ne divulguez pas la réponse secrète et le code de vérification, et gardez à l'esprit le problème de sécurité, qui vous aidera à récupérer votre mot de passe"
  },
  "xbsg":{
    "title": "Nouvelle pièce",
    "wdsg": "Des détails",
    "scts": "Jours de fermeture: ",
    "sy": "restant",
    "ljsg": "S'abonner",
    "ysk": "Solder",
    "xzjdy": "S'abonner",
    "dy": "S'abonner",
    "fxjg": "prix d'émission",
    "fxl": "Circulation",
    "ssrq": "Date d'inscription",
    "yxqx": "Période de validité",
    "qsrsl": "Veuillez saisir le montant",
    "syl": "restant",
    "sgrq": "s'abonner",
    "sgsl": "Montant",
    "bz": "Devise",
    "yebz": "Solde USDT insuffisant",
    "tgsl": "Qté de passage",
    "shz": "à l'étude",
    "wtg": "N'a pas passé",
    "ytg": "passé"
  },
  "wydb":{
    "title": "Emprunter",
    "db": "Emprunter",
    "dbz": "Emprunter",
    "jl": "des détails",
    "jdzq": "Période (jours)",
    "qhk": "Rembourser",
    "ljdb": "Cumul (USD)",
    "dhkbs" :"En attente de paiement",
    "jkje": "montant (USD)",
    "qsrje": "Veuillez saisir le montant",
    "rll": "Taux d'intérêt journalier",
    "hkfs": "Remboursement",
    "dqych": "Expiré",
    "lx": "L'intérêt",
    "fkjg": "Prêteur",
    "tpsc": "Prêt de crédit (téléchargement d'image)",
    "fwxx": "Informations sur le logement",
    "srzm": "Preuve de revenu (relation de travail)",
    "yhmx": "relevé bancaire",
    "zjz": "photo d'identité",
    "yd": "j'ai lu et j'accepte",
    "xy": "Demander un contrat de prêt",
    "sqdb": "demander des chaînes de prêt",
    "gb": "fermeture",
    "qd": "d'accord",
    "ts": "Veuillez cocher Demander un contrat de prêt",
    "dbjl": "des détails",
    "hkhth": "Code de commande",
    "wsh": "Non révisé",
    "yfk": "Prêt",
    "sqrq": "temps d'application",
    "zq": "cycle",
    "dbsl": "Nombre de côtes",
    "zhke": "Paiement total",
    "yhkxq": "Détails du remboursement",
    "bqyhk": "Remboursable dans la période en cours(USDT)",
    "hktips": "Veuillez vous assurer que le solde est suffisant, si le solde est insuffisant, veuillez d'abord recharger puis rembourser",
    "bj": "Principal",
    "jie": "Emprunter",
    "ljhk": "Remboursez immédiatement",
    "qcz": "Déposer",
    "yebzqxcz": "Solde insuffisant, veuillez d'abord recharger puis rembourser",
    "znj": "frais de retard",
    "yqts": "Jours en retard"
  },
  "hkxq":{
    "dd":"Commander",
    "fzhkdz":"Copiez l'adresse de remboursement",
    "hkxq": "Détails du remboursement",
    "zlx": "intérêt total",
    "zhk": "remboursements totaux",
    "hkjg": "agence de remboursement",
    "qschkpz": "Veuillez télécharger le certificat de remboursement",
    "hkpz": "certificat de remboursement"
  },
  "bbjyNew":{
    "jylx": "Type de transaction",
    "jyze": "Le total"
  },
  "indexNew":{
    "title": "Ajouter TokenSwap à l'interface principale",
    "t1": "Accès rapide à l'expérience plein écran",
    "t2": "Cliquez sur la barre d'outils ci-dessous",
    "t3": "et sélectionnez",
    "t4": "Ajouter à l'écran d'accueil",
    "t5": "Ajouter à l'expérience de bureau la version complète de TokenSwap",
    "t6": "Ajouter aux Favoris",
    "t7": "Trouver sur la page"
  },
  "bind":{
    "title": "E-mail",
    "ybd": "Bondir",
    "wbd": "Non lié",
    "yrz": "Vérifié",
    "wrz": "Non vérifié",
    "ts": "Pour protéger votre compte, il est recommandé de lier une adresse e-mail",
    "qsryxdz": "adresse e-mail"
  },
  "status":{
    "statusText": ['échec',"En attente d'être traité",'Succès'],
 },
 "tipsNew":{
   "wjmmts": "Récupérer le mot de passe par code de vérification",
   "qscpztp": "Téléchargement de l'image du bon",
   "emailgsts": "Veuillez entrer un email valide",
   "telgsts": "Le numéro de téléphone portable est incorrect",
   "lcmmbyz": "Veuillez confirmer votre mot de passe",
   "zdsl": "Le minimum ",
   "sldydy": "Quantité supérieure ou égale à",
   "zxtzsl": "Le minimum ",
   "ddz": "Attendre",
   "xs": "Heure",
   "min": "Montant minimal ",
   "max": "Quantité maximale ",
   "yebz": "Solde insuffisant",
   "qsrss": "Veuillez saisir le lot",
   "zdss": "Lots minimaux",
   "yjj": "rejeté",
   "shz": "rachat",
   "zwkfcz": "Cette devise n'est pas encore ouverte à la recharge",
   "jiaoge": "Livraison",
    "zhang": "monter",
    "die": "tomber",
    "cjxnzh": "Créer un compte virtuel"
 },
 "langNew2":{
  "flzq": "Centre de récompenses",
  "qdjl": "Récompense de connexion",
  "mrqdjl": "Récompense de connexion quotidienne",
  "qd": "S'identifier",
  "yqd": "Connecté",
  "hdgz": "Règles de l'événement",
  "qdjl2": "Enregistrement d'enregistrement",
  "qdcg": "Connectez-vous avec succès",
  "yhd": "Acquis",
  "lq": "Recevoir",
  "dyt": "Jour 1",
  "det": "Jour 2",
  "dst": "Jour 3",
  "dsit": "Jour 4",
  "dwt": "Jour 5",
  "dlt": "Jour 6",
  "dqt": "Jour 7",
  "jxz": "en cours"
},
"langNew":{
  "kp": "Ouverture",
  "zuoshou": "Reçu hier",
  "zg": "Le plus élevé",
  "zd": "le plus bas",
  "dqjg": "Prix ​​actuel",
  "pcjg": "Le dernier prix",
  "gd": "commande en cours",
  "gdj": "Prix de la commande en attente",
  "gdjg": "Prix de la commande en attente",
  "xfbzj": "Caution demandée: ",
  "ksrfw": "Plage d'entrée disponible: ",
  "shou": "Lots",
  "fdjyk": "résultat net flottant",
  "pcsl": "Quantité de clôture",
  "cx": "révoquer",
  "qrpc": "Confirmer pour fermer la position",
  "sx": "filtre",
  "cz": "réinitialiser",
  "zdl": "connaissait",
  "kccg": "Poste ouvert avec succès !",
  "xzfx": "choisir la direction",
  "lx": "taper",
  "xgcc": "modifier le poste",
  "szzyzs": "Définir le stop profit et le stop loss",
  "szhb": "Crypto-monnaie",
  "gjs": "Métal",
  "yy": "Brut",
  "jy": "Commerce",
  "jmhb": "Crypto-monnaie",
  "gdsj": "Tiempo de pedido pendiente",
  "gdsl": "Cantidad de pedido pendiente",
  "fs": "time"
 }
}



// WEBPACK FOOTER //
// ./src/utils/lang/fr.js